export default "__VITE_ASSET__qVhRVEnV__"